// Singleton toast handler for use outside React components
// This allows calling toast.success(), toast.error(), etc. from anywhere

let toastHandler = null;

export const setToastHandler = (handler) => {
  toastHandler = handler;
};

export const toast = {
  success: (message, options) => {
    if (toastHandler) {
      return toastHandler.addToast('success', message, options);
    }
    console.warn('Toast: ToastProvider not mounted');
    return null;
  },

  error: (message, options) => {
    if (toastHandler) {
      return toastHandler.addToast('error', message, options);
    }
    console.warn('Toast: ToastProvider not mounted');
    return null;
  },

  warning: (message, options) => {
    if (toastHandler) {
      return toastHandler.addToast('warning', message, options);
    }
    console.warn('Toast: ToastProvider not mounted');
    return null;
  },

  info: (message, options) => {
    if (toastHandler) {
      return toastHandler.addToast('info', message, options);
    }
    console.warn('Toast: ToastProvider not mounted');
    return null;
  },

  dismiss: (toastId) => {
    if (toastHandler) {
      toastHandler.removeToast(toastId);
    }
  },
};

export default toast;
